module.exports = __webpack_public_path__ + "img/00dc8cab195adc7255644a6b16792403.svg";